import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Tag } from '../Tag';
import styles from '@dtsl/css-badge/dist/index.module.css';
function Badge(props) {
  const {
    count = 100,
    overflowCount = 99,
    showZero = false,
    color = 'grey',
    styleVariant = 'filled',
    visible = true,
    className = '',
    badgeStyles = {},
    children,
    anchorOrigin = {},
    dataTestId = 'sib-badge-testId',
    badgeContentStyles = {}
  } = props;
  const [isVisible, setIsVisible] = useState(visible);
  const badgeClass = classNames({
    [styles['sib-badge-wrapper']]: true,
    [className]: !!className
  });
  const badgeContentClass = classNames({
    [styles['sib-badge']]: true,
    [styles[`sib-badge--${anchorOrigin.vertical}-${anchorOrigin.horizontal}`]]: Object.keys(anchorOrigin).length
  });
  const tagClass = classNames({
    [styles['sib-badge__content']]: true,
    [styles[`sib-badge__content--${color}`]]: true,
    [styles[`sib-badge__content--${styleVariant}`]]: true
  });
  const onAnimationEnd = () => {
    ReactDOM.flushSync(() => {
      if (!visible) {
        setIsVisible(false);
      }
    });
  };
  useEffect(() => {
    if (visible) {
      setIsVisible(true);
    }
    if (count === 0 && !showZero) {
      setIsVisible(false);
    }
  }, [visible, showZero, count]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isVisible ? /*#__PURE__*/React.createElement("div", {
    className: badgeClass,
    "data-testid": dataTestId
  }, children, /*#__PURE__*/React.createElement("span", {
    className: badgeContentClass,
    onAnimationEnd: onAnimationEnd,
    style: {
      ...badgeStyles,
      animation: `${visible ? 'var(--sib-transition_badge-pop-in, badge-pop-in 195ms cubic-bezier(0.4, 0, 0.2, 1) 0ms)' : 'var(--sib-transition_badge-pop-out, badge-pop-out 195ms cubic-bezier(0.4, 0, 0.2, 1) 0ms)'}`
    }
  }, /*#__PURE__*/React.createElement(Tag, {
    label: count > overflowCount ? `${overflowCount}+` : `${count}`,
    className: tagClass,
    styles: badgeContentStyles,
    labelStyles: {
      minWidth: '8px',
      textAlign: 'center'
    }
  }))) : children);
}
Badge.propTypes = {
  count: PropTypes.number,
  overflowCount: PropTypes.number,
  showZero: PropTypes.bool,
  color: PropTypes.oneOf(['grey', 'red']),
  styleVariant: PropTypes.oneOf(['filled', 'outline', 'borderless']),
  visible: PropTypes.bool,
  dataTestId: PropTypes.string,
  anchorOrigin: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
  badgeStyles: PropTypes.object,
  badgeContentStyles: PropTypes.object
};
export default Badge;